import React from 'react';
import {useQuery} from '@apollo/react-hooks';
import {gql} from 'apollo-boost';
import PropTypes from 'prop-types';
import {makeStyles} from 'tss-react/mui';
import {createTheme, ThemeProvider} from '@mui/material/styles';
import TextField from '@mui/material/TextField';
import IconButton from '@mui/material/IconButton';
import InputAdornment from '@mui/material/InputAdornment';
import Avatar from '@mui/material/Avatar';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemAvatar from '@mui/material/ListItemAvatar';
import ListItemText from '@mui/material/ListItemText';
import DialogTitle from '@mui/material/DialogTitle';
import Dialog from '@mui/material/Dialog';
import {blue} from '@mui/material/colors';
import EditIcon from '@mui/icons-material/Edit';

import {genQuery} from '../../../common/helpers';

const theme = createTheme();
const useStyles = makeStyles()((theme) => ({
   avatar: {
      backgroundColor: blue[100],
      color: blue[600]
   },
   textField: {
      marginTop: '8px',
      marginLeft: '8px',
      marginRight: '8px',
      width: '100%'
   }
}));

const ItemsQuery = (props) => {
   const {classes} = useStyles();
   const {onClose} = props;
   const {data, error, loading} = useQuery(
      gql`
         ${props.query}
      `
   );
   if (loading)
      return (
         <ListItem button key="loading" value="loading">
            Cargando...
         </ListItem>
      );
   if (error)
      return (
         <ListItem button key="loading" value="loading">
            {`Error: ${error}`}
         </ListItem>
      );

   function handleListItemClick(value) {
      onClose(value);
   }
   return (
      <>
         {data[props.alias].map((item) => (
            <ListItem
               button
               onClick={() => handleListItemClick(item[props.campos[0]])}
               key={item[props.campos[0]]}
            >
               <ListItemAvatar>
                  <Avatar className={classes.avatar}></Avatar>
               </ListItemAvatar>
               <ListItemText primary={item[props.campos[1]]} />
            </ListItem>
         ))}
      </>
   );
};
ItemsQuery.propTypes = {
   onClose: PropTypes.func.isRequired
   /*query: PropTypes.string.isRequired,
  alias: PropTypes.string.isRequired,*/
   /*open: PropTypes.bool.isRequired,
  selectedValue: PropTypes.string.isRequired,*/
};
const ItemsData = (props) => {
   const {classes} = useStyles();
   const {onClose} = props;
   function handleListItemClick(value) {
      onClose(value);
   }

   return (
      <>
         {props.data.map((item) => (
            <ListItem button onClick={() => handleListItemClick(item.codigo)} key={item.codigo}>
               <ListItemAvatar>
                  <Avatar className={classes.avatar}></Avatar>
               </ListItemAvatar>
               <ListItemText primary={item.valor} />
            </ListItem>
         ))}
      </>
   );
};

const DialogDB = (props) => {
   const {onClose, selectedValue, open} = props;

   function handleClose() {
      onClose(selectedValue);
   }

   return (
      <Dialog onClose={handleClose} aria-labelledby="dialogDB" open={open}>
         <DialogTitle id="dialogDBTitulo">Selecciona</DialogTitle>
         <List>
            {props.query && props.query !== '' && !props.data ? (
               <ItemsQuery
                  onClose={onClose}
                  query={genQuery(props.alias, props.campos, props.atributos)}
                  alias={props.alias}
                  campos={props.campos}
               />
            ) : (
               <ItemsData onClose={onClose} data={props.data} />
            )}
         </List>
      </Dialog>
   );
};

DialogDB.propTypes = {
   onClose: PropTypes.func.isRequired,
   open: PropTypes.bool.isRequired,
   selectedValue: PropTypes.string.isRequired
};

export default function SearchDB(props) {
   //Inicializar Estilos del componente
   const {classes} = useStyles();

   //Estados
   const [values] = React.useState(props);
   const [open, setOpen] = React.useState(false);
   const [selectedValue, setSelectedValue] = React.useState(props.selectedValue);

   const handleClickOpen = () => {
      setOpen(true);
   };

   const handleClose = (value) => {
      setOpen(false);
      setSelectedValue(value);
      props.setSelectedValue(value);
   };

   return (
      <ThemeProvider theme={theme}>
         <TextField
            id={values.id}
            label={values.label}
            className={classes.textField}
            value={props.selectedValue ? props.selectedValue : ''}
            margin="normal"
            InputProps={{
               endAdornment: (
                  <InputAdornment position="end">
                     <IconButton edge="end" onClick={handleClickOpen} size="large">
                        <EditIcon />
                     </IconButton>
                  </InputAdornment>
               )
            }}
         />
         <DialogDB
            selectedValue={selectedValue}
            open={open}
            onClose={handleClose}
            alias={props.alias}
            campos={props.campos}
            atributos={props.atributos}
            data={props.data}
         />
      </ThemeProvider>
   );
}
SearchDB.defaultProps = {
   selectedValue: ''
};

/*export default SearchDB;*/
